import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { FlightchangehistoryComponent } from "./component/flightchangehistory/flightchangehistory.component";
import { FormsModule } from "@angular/forms";
import { CookieService } from "ngx-cookie-service";
import { ConsumeRestApiService } from "./services/consume-rest-api.service";
import { WindowRefService } from "./services/window-ref.service";
import { DocumentRefService } from "./services/document-ref.service";
import { LogInStatusService } from "./services/loginStatus.service";
import { SessionDialogComponent } from "../app/component/session-dialog/session-dialog.component";
import { ModuleFederationToolsModule } from "@angular-architects/module-federation-tools";
import { FlightDetailsComponent } from "./component/flight-details/flight-details.component";
import { FlightCardComponent } from "./component/flight-card/flight-card.component";
import { TripUpdateCardComponent } from "./component/trip-update-card/trip-update-card.component";
import { TealiumUtagService } from "./services/utag.service";
import { SystemErrorComponent } from "./component/system-error/system-error.component";
import { SpinnerComponent } from "../app/component/spinner/spinner.component";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import '@aileron-web/header';
import '@aileron-web/footer';
import '@aileron/dialog';
import { APP_BASE_HREF } from "@angular/common";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "src/environments/environment";

@NgModule({ declarations: [
        AppComponent,
        FlightchangehistoryComponent,
        FlightDetailsComponent,
        FlightCardComponent,
        TripUpdateCardComponent,
        SystemErrorComponent,
        SpinnerComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
        BrowserModule,
        FormsModule,
        ModuleFederationToolsModule,
        SessionDialogComponent,
        RouterModule.forRoot([]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        })], providers: [
        DocumentRefService,
        WindowRefService,
        ConsumeRestApiService,
        CookieService,
        TealiumUtagService,
        LogInStatusService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  constructor() {}
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.i18nBaseUrl);
}
